import { Link } from 'react-router-dom';

import Page from '@components/Page';
import PageHeader from '@components/PageHeader';
import PohContainer from '@ui-kit/layout/Container';

import allRoutes, { IPohodnikRouterItem } from '../routes';

interface TreeNodeData {
  segment: string;
  children: Record<string, TreeNodeData>;
  meta: IPohodnikRouterItem | null;
}

/**
 * Строит дерево из плоского списка маршрутов.
 * Возвращает массив корневых узлов.
 */
function buildTree(routes: IPohodnikRouterItem[]) {
  const root: TreeNodeData = { children: {}, segment: '', meta: null };

  routes.forEach((route) => {
    // Разбиваем путь на сегменты и убираем пустые
    const segments = route.path.split('/').filter(Boolean);
    let current = root;

    segments.forEach((segment, index) => {
      if (!current.children[segment]) {
        current.children[segment] = {
          segment,
          children: {},
          meta: null, // сюда попадёт info, если маршрут заканчивается на этом сегменте
        };
      }
      current = current.children[segment];

      // Если это последний сегмент — сохраняем метаданные маршрута
      if (index === segments.length - 1) {
        current.meta = route;
      }
    });
  });

  return root;
}

const TreeNode = ({ node }: { node: TreeNodeData }) => {
  const children = Object.values(node.children);

  return (
    <li>
      {node.meta ? (
        <>
          <span>{node.meta.title}</span>
          &nbsp;
          {node.meta.path.includes(':') ? (
            <code style={{ marginLeft: 8, color: '#888' }}>{node.meta.path}</code>
          ) : (
            <Link to={node.meta.path}>{node.meta.path}</Link>
          )}
          {node.meta.protected && (
            <span style={{ marginLeft: 8, color: 'red' }} title="Protected">
              🔒
            </span>
          )}
        </>
      ) : (
        <em style={{ color: '#aaaaaa' }}>{node.segment}</em>
      )}

      {children.length > 0 && (
        <ul>
          {children.map((child) => (
            <TreeNode key={child.segment} node={child} />
          ))}
        </ul>
      )}
    </li>
  );
};

const SiteMap = () => {
  const tree = buildTree(allRoutes.filter((x) => !!x.title));
  const roots = Object.values(tree.children);

  return (
    <PohContainer>
      <Page title="Карта сайта">
        <PageHeader title="Карта сайта"></PageHeader>
        <ul>
          {roots.map((node) => (
            <TreeNode key={node.segment} node={node} />
          ))}
        </ul>
      </Page>
    </PohContainer>
  );
};

export default SiteMap;
